<template>
    <div class="order-status-item">
        <div class="dispatching order" v-if="isDispatching" @click="goToTimeline">
            <img src="@/assets/img/mate.svg">
            配對中
            <span>任務#{{ order.id }}</span>
        </div>
        <div class="missing order" v-if="isMessing" @click="goToTimeline">
            <img src="@/assets/img/warning.svg">
            暫停配對
            <span>請點擊查看</span><img src="@/assets/img/next-white.svg">
        </div>
        <div class="processing order" v-if="isWaitGoLocation" @click="goToTimeline">
            <img src="@/assets/img/success-broder.svg">
            預約成功
            <span>{{ waitMsg }}</span>
        </div>
        <div class="processing order" v-if="isProcessing && !isWaitGoLocation" @click="goToTimeline">
            <img src="@/assets/img/run.svg">
            執行中
            <span v-show="! location.arrived_at">前往</span>
            <span v-show="location.arrived_at">抵達</span>
            <div>{{ location.alias || location.road }}</div>
        </div>
        <div class="debt order" v-if="isDebt" @click="goToOrder">
            <img src="@/assets/img/warning.svg">
            您尚有欠款
            <span>請點擊前往繳費</span><img src="@/assets/img/next-white.svg">
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'OrderStatusItem',
        props: {
           order: {
               require: true,
               type: Object,
           }
        },
        computed: {
            isDispatching() {
                return this.order.status === 'dispatching' || this.order.status === 'sending' || this.order.status === 'appointing';
            },
            isMessing() {
                return this.order.status === 'missing';
            },
            isWaitGoLocation() {
                return this.order.status === 'processing' && this.order.reserved_at && ! this.order.locations[0].arrived_at;
            },
            waitMsg() {
                if (! this.order.reserved_at) {
                    return '';
                }

                let reservedAt = moment(this.order.reserved_at);
                let day = reservedAt.format('MM/DD');
                let time = reservedAt.format('HH:mm');
                if (moment().isSame(reservedAt, 'day')) {
                    day = '今日';
                }

                return `將於 ${day} ${time} 開始執行`;
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            isDebt() {
                return this.order.is_debt;
            },
            location() {
                return this.order.locations.find(location => !location.arrived_at || !location.left_at);
            },
        },
        methods: {
            goToTimeline() {
                this.$emit('onClose');
                let payload = {
                    name: 'timeline',
                    params: {
                        id: this.order.id,
                    },
                };

                if (this.$route.name === 'timeline') {
                    this.$router.replace(payload);
                } else {
                    this.$router.push(payload);
                }
            },
            goToOrder() {
                this.$emit('onClose');
                let payload = {
                    name: 'order',
                    params: {
                        id: this.order.id,
                    }
                };

                if (this.$route.name === 'order') {
                    this.$router.replace(payload);
                } else {
                    this.$router.push(payload);
                }
            },
        },
        filters: {
            timeFormat(value) {
                value = String(value);
                if (value.length < 2) {
                    value = '0' + value;
                }

                return value;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .order-status-item {
        margin-top: 5px;
        user-select: none;

        .order {
            border-radius: 4px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-left: 25px;
            overflow: hidden;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 22px;
            white-space: nowrap;
            cursor: pointer;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);

            span {
                margin-left: 15px;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
            }

            div {
                margin-left: 5px;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            img {
                margin-right: 5px;
            }
        }

        .dispatching {
            background-color: #4A90E2;
        }

        .processing {
            background-color: #339933;

            span {
                font-size: 12px !important;
                line-height: 17px !important;
            }
        }

        .missing {
            background-color: #999999;
        }

        .debt {
            background-color: #FF695E;
        }
    }
</style>
